import {Member} from "../member/member";

export class MemberPost {
  id: number;
  title: string;
  thumbnail: string;
  contact: string;
  email: string;
  homepage: string;
  summary: string;
  content: string;
  location?: any;
  createdDate?: string;
  author?: Member;
}

export class MemberPostPage {
  content: MemberPost[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
}



// WEBPACK FOOTER //
// ./src/app/service/member-post/member-post.ts